import type { AxiosError } from 'axios';

/** Mensaje amigable para mostrar en UI (listados, formularios, toasts). */
export function getApiErrorMessage(error: unknown, fallback = 'Ocurrió un error. Reintentá.'): string {
  if (!error) return fallback;

  const ax = error as AxiosError<any> & { friendlyMessage?: string };
  if (typeof ax.friendlyMessage === 'string' && ax.friendlyMessage.trim()) {
    return ax.friendlyMessage;
  }

  const status = ax.response?.status;
  const data = ax.response?.data;
  const raw =
    typeof data?.message === 'string'
      ? data.message
      : Array.isArray(data?.message)
        ? data.message.filter((m: unknown) => typeof m === 'string').join('. ')
        : typeof data?.error === 'string'
          ? data.error
          : null;

  if (!ax.response || status === 502 || status === 503 || status === 504) {
    if (status === 504) {
      return 'La operación tardó demasiado. Probá con menos datos o un rango de fechas más chico, y reintentá.';
    }
    if (status === 503) {
      return 'El servicio está temporalmente saturado. Esperá unos segundos y reintentá.';
    }
    // Sin response = red caída / API caída; 502 = gateway sin upstream
    return 'El servidor no respondió (puede estar reiniciando o saturado). Esperá unos segundos y reintentá.';
  }

  if (raw && !looksLikeHtmlOrNginx(raw)) return raw;
  if (typeof ax.message === 'string' && ax.message && !looksLikeHtmlOrNginx(ax.message)) {
    if (ax.message === 'Network Error') {
      return 'No hay conexión con el servidor. Revisá tu red o reintentá en unos segundos.';
    }
    return ax.message;
  }

  return fallback;
}

function looksLikeHtmlOrNginx(msg: string): boolean {
  const t = msg.trim().toLowerCase();
  return (
    t.includes('<html') ||
    t.includes('<!doctype') ||
    t.includes('502 bad gateway') ||
    t.includes('504 gateway') ||
    t.includes('nginx')
  );
}
